'use client';

import {
  SalesPrice as SalesPriceComponent,
  SalesPriceCurrent,
  SalesPriceFormer
} from '@coolblue-development/next-sales-price/client';
import { useTranslation } from '@i18n/useTranslation';

type SalesPriceProps = {
  currentPrice: number;
  formerPrice: number;
};

const SalesPrice = ({ currentPrice, formerPrice }: SalesPriceProps) => {
  const { t } = useTranslation('webshop');

  return (
    <SalesPriceComponent
      currentPrice={<SalesPriceCurrent price={currentPrice} />}
      formerPrice={
        formerPrice ? (
          <SalesPriceFormer price={formerPrice} prefix={t('orderBlock.salesPrice.prefix')} />
        ) : undefined
      }
    />
  );
};

export default SalesPrice;
